import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import { ISitemap } from '.';

export type TAdminGetSitemaps = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetSitemapsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetSitemaps) => {
  let path = `${AdminApiPaths.sitemap}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<ISitemap>>
  >(path);

  return response.data;
};

export const adminGenerateSitemap = createAsyncThunk(
  '/admin/sitemap/create',
  async () => {
    const path = `${AdminApiPaths.sitemap}`;

    const response = await apiDataProvider.post<TApiResponse<ISitemap>>(
      path,
      {}
    );

    return response.data;
  }
);

export const adminGetSitemaps = createAsyncThunk(
  '/admin/sitemap/list',
  adminGetSitemapsModule
);
